export const parseNumberFromFormatted = (formatted) =>
  formatted?.toString().replace(/,/g, '') || '';

export const formatNumberWithCommas = (value) => {
  if (value === null || value === undefined || value === '') return '';

  const valueStr = value.toString();
  const parts = valueStr.split('.');
  const integerPart = parts[0].replace(/,/g, '');
  let decimalPart = parts[1];

  const formattedInteger = new Intl.NumberFormat('en-US').format(Number(integerPart));

  // Case: user ends input with '.' but no decimal part yet
  if (valueStr.endsWith('.') && decimalPart === undefined) {
    return `${formattedInteger}.`;
  }

  // Limit to two digits after the decimal
  if (decimalPart !== undefined) {
    decimalPart = decimalPart.substring(0, 2);
    return `${formattedInteger}.${decimalPart}`;
  }

  return formattedInteger;
};
